import { AUTH_LOGIN_CONTEXT_KEY, AUTH_USERDATA_KEY } from 'features/auth/constants';

export const deleteUserData = () => {
  localStorage.removeItem(AUTH_USERDATA_KEY);
  deleteToken();
};

export const deleteToken = () => {
  localStorage.removeItem(AUTH_LOGIN_CONTEXT_KEY);
};
